import type { PdpConfig } from '#types/config/pages/pdp'
import type { RecursivePartial } from '#types/utils'

export default {
  allowOutOfStockSelection: true,
  benefitRatingsMaxScale: 3,
  brandClasses: {
    breadcrumbs: 'mt-4 text-sm lg:mb-4 md:(mb-2 mt-6)',
    ctasWrapper: 'b-t b-grey-70 pb-8 pt-4 space-y-4',
    eSpotAboveAccordions: 'mb-6',
    eSpotAboveAddToCart: 'mt-4 [&_.bg-brand-6]:w-full',
    eSpotBelowSizes: 'mt-4',
    eSpotLazyAboveFooter: 'pb-20 pt-12 <md:(b-t b-grey-70) [&_.container]:px-0',
    eSpotLazyBelowGallery: '<md:pb-8',
    headingProductName: 'title-2',
    headingPrice: 'mt-4',
    klarnaPayments: 'mt-4',
    paypalPayments: 'mt-4',
    reviewsCount: 'self-center text-base <lg:mb-2',
    reviewsHeading: 'title-2 text-center',
    reviewsLink: 'items-center gap-2 i-flex',
    reviewsItemsContainer: 'space-y-6',
    reviewsListContainer: 'space-y-8',
    reviewsRecommendations: 'mb-2',
    reviewsRatingSummary: 'b-t b-grey-70 py-4',
    reviewsSearchSortContainer: 'space-y-4',
    reviewsSearchSubmit: 'rounded-r-xs bg-brand-2 c-white p-1',
    reviewsSearchWrapper: 'bg-grey-90 p-4 text-center lg:(flex items-center between) <md:-mx-4',
    reviewsSnapshotWrapper: 'grid gap-4',
    reviewsWrapper: 'text-sm space-y-6',
    shopTheLookButton: 'uppercase fw-bold',
    shopTheLookDialog: 'lg:(w-248 pb-6) <lg:overflow-x-hidden',
    sizeChartDialog: '',
    upsellsWrapper: 'mb-6',
    variantSelectionLabel: {
      base: 'text-sm',
      size: ''
    },
    variantSelectionGroupedOptionsGreaterThanOne: 'mb-4',
    variantSelectionGroupedOptionsPrice: 'mb-2',
    variantSelectionWrapper: 'b-t b-grey-70 pt-4 space-y-4'
  },
  details: {
    ctaSize: {
      sm: 'sm',
      lg: 'md'
    },
    ctaVariant: 'tertiary',
    favoriteCta: {
      iconSize: 'md',
      iconOnly: false,
      variantSelected: 'tertiary-inverse'
    },
    findInStoreCta: {
      showIcon: true
    }
  },
  gallery: {
    loop: true,
    videoFit: 'contain',
    presets: {
      src: {
        width: 650,
        height: 650
      },
      srcZoom: {
        width: 1300,
        height: 1300
      }
    }
  },
  questions: {
    pageSize: 6
  },
  quickshop: {
    dialogOptions: {
      type: { sm: 'panel', md: 'modal' },
      position: 'bottom'
    }
  },
  reviews: {
    dialogOptions: {
      reviews: { type: { sm: 'panel', md: 'modal' } },
      reviewWrite: { type: { sm: 'panel', md: 'modal' } },
      filters: { type: 'panel' }
    },
    filterOptionsMaxNumber: 7,
    iconSize: 'lg',
    mostLikedCommentTextThreshold: 225,
    nonFilterKeys: ['cons', 'pros'],
    pageSize: 6,
    prosAndConsMaxNumber: 6,
    recommendationRateThreshold: 74,
    showFilters: true,
    showRatingBreakdown: true,
    showWriteReviewCta: true
  },
  shopTheLook: {
    mediaSize: {
      width: 120,
      height: 120
    },
    mediaTransformations: {
      alignFill: 'center',
      unSharpMask: 100
    },
    dialogOptions: {
      type: { sm: 'panel', md: 'modal' },
      size: { sm: 'sm' },
    },
    productSetThreshold: 3
  },
  showAddToCartCta: true,
  showBreadcrumbsLastStep: true,
  sizeAndFit: {
    showFitRating: true,
    showHeading: true,
    showModelMeasurements: true,
    showSizeChartIcon: true
  },
  sizeChart: {
    dialogOptions: { type: { sm: 'panel', md: 'modal' } }
  },
  stickyHeader: {
    thumbnail: {
      height: 64,
      width: 59
    }
  },
  swatches: {
    collapseThreshold: 24,
    size: { sm: 'sm', lg: 'md' },
    variant: 'round'
  },
  tryItOn: {
    dialogOptions: { type: { sm: 'panel', md: 'modal' } }
  },
  variantSelection: {
    dialogOptions: {
      type: 'panel',
      size: 'lg'
    }
  }
} satisfies RecursivePartial<PdpConfig>
